export default function customTagFilter(item, queryText, getIsTechnicalTagLabel) {
  if (!queryText) {
    return true;
  }
  if (!getIsTechnicalTagLabel && item.tagAlias) {
    return item.tagAlias.toLowerCase().includes(queryText.toLowerCase());
  }
  return item.tagName.toLowerCase().includes(queryText.toLowerCase());
}
